import { computed } from "@preact/signals";
import { useProductSelector } from "$store/sdk/useProductSelector.tsx";
import QuantitySelector from "$store/components/ui/QuantitySelector.tsx";
import Icon from "$store/components/ui/Icon.tsx";

interface Props {
  sku: string;
  seller?: string;
  inventoryLevel?: number;
}

export default function AddToCart(
  { sku, seller = "1", inventoryLevel }: Props,
) {
  const { selectedProducts, handleQuantity, handleSelect } =
    useProductSelector();

  const quantity = computed(() =>
    selectedProducts.value.find((product) => product.sku === sku)
      ?.quantity ?? 1
  );

  const isSelected =
    selectedProducts.value.find((product) => product.sku === sku)
      ?.isSelected ??
      false;

  return (
    <div class="flex items-center gap-1 lg:flex-row-reverse lg:gap-6 lg:shrink-0">
      <div class="flex items-center gap-1">
        <div class="relative leading-[0]">
          <input
            id={`media-shelf-product-${sku}`}
            class="w-6 h-6 border border-tw-secondary-200 rounded appearance-none checked:bg-tw-secondary-200 cursor-pointer"
            type="checkbox"
            checked={isSelected}
            onChange={() => handleSelect(sku, !isSelected, seller)}
          />

          <Icon
            id="Check"
            class="text-white absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
            size={11}
          />
        </div>

        <label
          class={`min-w-[5rem] text-sm leading-5 font-bold cursor-pointer ${
            isSelected ? "text-tw-secondary-200" : "text-tw-neutral-500"
          }`}
          htmlFor={`media-shelf-product-${sku}`}
        >
          {isSelected ? "Selecionado" : "Selecionar"}
        </label>
      </div>

      <QuantitySelector
        quantity={quantity.value}
        max={inventoryLevel}
        onChange={(q) => handleQuantity(sku, q)}
      />
    </div>
  );
}
